<template>
    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
            </Breadcrumb>
                <h5>{{ show_name }} Vehicle</h5>
                <hr>
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <!-- <InputText id="vehicle_type" type="text" v-model="product.vehicle_type"
                                :class="{ 'p-invalid': submitted && !product.vehicle_type }" /> -->
                                <Dropdown   id="User" filter
                                    v-model="dropdownItem" 
                                    :options="dropdownItems" 
                                    optionLabel="name"
                                    :class="{ 'p-invalid': submitted && !dropdownItem }">
                        </Dropdown>
                            <label for="vehicle_type">Vehicle Type</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <Dropdown id="status" v-model="status_dropdownItem" :options="status_dropdownItems"
                                optionLabel="name" :class="{ 'p-invalid': submitted && !status_dropdownItem }">
                            </Dropdown>
                            <label for="status">Status</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="registration_number" type="text" v-model="product.registration_number" maxlength="10"
                                :class="{ 'p-invalid': submitted && !product.registration_number }" />
                            <label for="registration_number">Registration No.</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">

                            <InputText type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10" id="mobile_number_rc" v-model="product.mobile_number_rc"
                                :class="{ 'p-invalid': submitted && !product.mobile_number_rc }" />
                            <label for="mobile_number_rc">Mobile No Connected to Rc</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="rc_number" type="text" v-model="product.rc_number"
                                :class="{ 'p-invalid': submitted && !product.rc_number }" />
                            <label for="rc_number">Rc No.</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                                <InputText id="make" type="text" v-model="product.make"
                                :class="{ 'p-invalid': submitted && !product.make }" />
                                <!-- <Calendar inputId="make" v-model="product.make" view="year" dateFormat="yy" :class="{ 'p-invalid': submitted && !product.make }"/>-->
                            <label for="make">Make By</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="model" type="text" v-model="product.model"
                                :class="{ 'p-invalid': submitted && !product.model }" />
                            <label for="model">Model</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="color" type="text" v-model="product.color"
                                :class="{ 'p-invalid': submitted && !product.color }" />
                            <label for="color">Enter Vehicle Color</label>
                        </span>
                    </div>
                    
                    
                    
                    
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="fuel_type" type="text" v-model="product.fuel_type"
                                :class="{ 'p-invalid': submitted && !product.fuel_type }" />
                            <label for="fuel_type">Fuel Type</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            
                                <Calendar inputId="make_year" v-model="product.make_year" view="year" dateFormat="yy" :class="{ 'p-invalid': submitted && !product.make_year }"/>
                            <label for="make_year">Make Year</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                       
                                <Calendar inputId="fitness_validity" v-model="product.fitness_validity"  dateFormat="dd-mm-yy" 
                                :class="{ 'p-invalid': submitted && !product.fitness_validity }"/>
                            <label for="fitness_validity">Fitness Validity</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                          

                                <Calendar inputId="puc_validity" v-model="product.puc_validity"  dateFormat="dd-mm-yy" 
                                :class="{ 'p-invalid': submitted && !product.puc_validity }"/>
                            <label for="puc_validity">PUC Validity</label>
                        </span>
                    </div>
                    
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                         

                                <Calendar inputId="insurance_validity" v-model="product.insurance_validity"  dateFormat="dd-mm-yy" 
                                :class="{ 'p-invalid': submitted && !product.insurance_validity }"/>
                            <label for="insurance_validity">Insurance Validity</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="bcnt" type="text" v-model="product.bcnt"
                                :class="{ 'p-invalid': submitted && !product.bcnt }" />
                            <label for="bcnt">Base City Name Of Tranportation</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <!-- <InputText id="vehicle_type" type="text" v-model="product.vehicle_type"
                                :class="{ 'p-invalid': submitted && !product.vehicle_type }" /> -->
                                <Dropdown   id="User" filter
                                    v-model="district_dropdownItem" 
                                    :options="district_dropdownItems" 
                                    optionLabel="name"
                                    :class="{ 'p-invalid': submitted && !district_dropdownItem }">
                        </Dropdown>
                            <label for="vehicle_type">District</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <!-- <InputText id="vehicle_type" type="text" v-model="product.vehicle_type"
                                :class="{ 'p-invalid': submitted && !product.vehicle_type }" /> -->
                                <Dropdown   id="User" filter
                                    v-model="block_dropdownItem" 
                                    :options="block_dropdownItems" 
                                    optionLabel="name"
                                    :class="{ 'p-invalid': submitted && !block_dropdownItem }">
                        </Dropdown>
                            <label for="vehicle_type">Block</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <!-- <InputText id="vehicle_type" type="text" v-model="product.vehicle_type"
                                :class="{ 'p-invalid': submitted && !product.vehicle_type }" /> -->
                                <Dropdown   id="User" filter
                                    v-model="village_dropdownItem" 
                                    :options="village_dropdownItems" 
                                    optionLabel="name"
                                    :class="{ 'p-invalid': submitted && !village_dropdownItem }">
                        </Dropdown>
                            <label for="vehicle_type">Village</label>
                        </span>
                    </div>
                    

                    <!-- upload photo code working but code hide 15-5-23 bulk add -->
                    <!-- <div class="field col-12 md:col-2" style="margin-top: 1%;">
                        <h5>Document(Photo)</h5>
                       
                        <FileUpload
                        v-tooltip.bottom="'Upload Photo'"
                  mode="basic"
                  id="file_attachment"
                  ref="file_attachment"
                  @change="handleFileUpload"
                  name="demo[]"
                  accept="application/pdf,image/jpeg,image/png"
                  :maxFileSize="10000000"
                />
                    </div>
                <div class="field col-12 md:col-10" style="margin-top: 1%;">
                <a v-if="this.product.photos && this.product.photos[0]" :href="this.product.photos[0]"><b><u>view</u></b> </a>
            </div> -->
        

            <!-- add excel functionality start -->
            <div class="field col-12 md:col-2" style="margin-top: 1%;">
            <Button
               style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
               label="ADD"
               icon="pi pi-check"
               class="p-button mr-1 mb-1"
               @click="adduser"
               v-tooltip.bottom="'Add Vehicle'"
             />
             
            </div>
            <div class="field col-12 md:col-10" style="margin-top: 1%;text-align:right;">
                <FileUpload  mode="basic" id="fileupload1" ref="fileupload1" chooseLabel="Import Vehicle"    :maxFileSize="1000000" @change="fileuploaduser($event)" style="background-color: #1C4C74" />
            </div>

            <div class="field col-12 md:col-12" style="margin-top: 1%;">
                <DataTable 
                  :value="products" 
                  :loading="loading"
                  :lazy="true"
                  :rows="limit"
                  :filters="filters"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  :rowsPerPageOptions="[5, 10, 25]"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  responsiveLayout="scroll"
                  style="font-size: 12px"
                  :rowHover="true" 
                  showGridlines>
                    <template #empty>
                    <b style="text-align:center">No records found.</b>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0">
                                <b> New Vehicle List</b>
                            </h5>
                                    Total Records:{{this.products.length}}
                        </div>
                    </template>
                    <!-- <Column header="Status" style="min-width: 8rem ;text-align: center;" headerStyle="min-width:2rem;" >
                        <template #body="{ data }"> 
                            <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
                            <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
                            <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
                            <span v-else>-</span>
                        </template>
                    </Column> -->
                    <Column field="registration_number" headerStyle="min-width:10rem;" header="Reg No">
                        <template #body="{ data }">
                            <InputText
                                    id="registration_number"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.registration_number"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="mobile_number_rc" headerStyle="min-width:10rem;" header="Mob No">
                        <template #body="{ data }">
                            <InputText                                    
                                    id="mobile_number_rc"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.mobile_number_rc"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="rc_number" headerStyle="min-width:10rem;" header="RC No">
                        <template #body="{ data }">
                            <InputText
                                    id="rc_number"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.rc_number"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="make" headerStyle="min-width:10rem;" header="Make">
                        <template #body="{ data }">
                            <InputText
                                    id="make"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.make"
                                    required="true"
                                    autofocus
                                    />
                                    <!--<Calendar inputId="make_year" 
                                        v-model="data.make" 
                                        view="year" 
                                        dateFormat="yy" 
                                        />-->
                        </template>
                    </Column>
                    <Column field="model" headerStyle="min-width:10rem;" header="Model">
                        <template #body="{ data }">
                            <InputText
                                    id="model"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.model"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="color" headerStyle="min-width:10rem;" header="Color">
                        <template #body="{ data }">
                            <InputText
                                    id="color"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.color"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="vehicle_type" headerStyle="min-width:10rem;" header="Type">
                        <template #body="{ data }">
                            <Dropdown   id="User" filter
                                    v-model="data.dropdownItem" 
                                    :options="dropdownItems" 
                                    optionLabel="name"
                                    >
                        </Dropdown>
                        </template>
                    </Column>
                    <Column field="fuel_type" headerStyle="min-width:10rem;" header="Fuel">
                        <template #body="{ data }">
                            <InputText
                                    id="fuel_type"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.fuel_type"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="make_year" headerStyle="min-width:10rem;" header="Make Year">
                        <template #body="{ data }">
                            <Calendar inputId="make_year" 
                                        v-model="data.make_year" 
                                        view="year" 
                                        dateFormat="yy" 
                                        />
                        </template>
                    </Column>
                    <Column field="fitness_validity" headerStyle="min-width:10rem;" header="Fitness">
                        <template #body="{ data }">
                            <Calendar inputId="fitness_validity" 
                                        v-model="data.fitness_validity" 
                                        view="year" 
                                        dateFormat="yy-mm-dd" 
                                        />
                        </template>
                    </Column>
                    <Column field="puc_validity" headerStyle="min-width:10rem;" header="PUC">
                        <template #body="{ data }">
                            <Calendar inputId="puc_validity" 
                                        v-model="data.puc_validity" 
                                        view="year" 
                                        dateFormat="yy-mm-dd" 
                                        />
                        </template>
                    </Column>
                    <Column field="insurance_validity" headerStyle="min-width:10rem;" header="Insurance">
                        <template #body="{ data }">
                            <Calendar inputId="insurance_validity" 
                                        v-model="data.insurance_validity" 
                                        view="year" 
                                        dateFormat="yy-mm-dd" 
                                        />
                        </template>
                    </Column>
                    <Column field="bcnt" headerStyle="min-width:10rem;" header="City Of Tranp.">
                        <template #body="{ data }">
                            <InputText
                                    id="bcnt"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.bcnt"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column field="district" headerStyle="min-width:10rem;" header="District">
                        <template #body="{ data }">
                            <Dropdown   id="User" filter
                                    v-model="data.district_dropdownItem" 
                                    :options="district_dropdownItems" 
                                    optionLabel="name"
                                    >
                        </Dropdown>
                        </template>
                    </Column>
                    <Column field="block" headerStyle="min-width:10rem;" header="Block">
                        <template #body="{ data }">
                            <Dropdown   id="User" filter
                                    v-model="data.block_dropdownItem" 
                                    :options="block_dropdownItems" 
                                    optionLabel="name"
                                    >
                        </Dropdown>
                        </template>
                    </Column>
                    <Column field="village" headerStyle="min-width:10rem;" header="Village">
                        <template #body="{ data }">
                            <Dropdown   id="User" filter
                                    v-model="data.village_dropdownItem" 
                                    :options="village_dropdownItems" 
                                    optionLabel="name"
                                    >
                        </Dropdown>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="min-width:2rem;">
              <template #body="slotProps">
               
                <Button
                  style="background-color: #1C4C74"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button mt-2"
                  @click="confirmDeleteProduct(slotProps.data)"
                />
              </template>
            </Column>
                </DataTable>
            </div>
            <!-- add excel functionality end -->







           
            <div class="field col-12 md:col-4" style="margin-top: 1%;"></div>
                    <div class="field col-12 md:col-2" style="margin-top: 1%;">
                        <!-- <Button v-if="product._id" label="Update" class="p-button-success mr-2" @click="Add_user" v-tooltip.bottom="'Update'" /> -->
                        <Button  label="Submit" class="p-button mr-2" @click="submit_details" v-tooltip.bottom="'Submit'" style="background-color: white; border: 1px solid #349CE4; color: #349CE4;" />
                    </div>
                    <div class="field col-12 md:col-2" style="margin-top: 1%;">
                        <Button label="Reset" class="p-button-danger mr-2" v-tooltip.bottom="'Reset'" @click="reset_user" style="background-color: #349CE4; border: 1px solid #349CE4;" />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
import readXlsxFile from 'read-excel-file'
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
export default {
    data() {
        return {

            limit: 10,
            filters: {},
            products: [],
            status: "",

            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment:'',
            dropdownItems: [],
            dropdownItem: null,


            district_dropdownItems: [],
            district_dropdownItem: null,
            block_dropdownItems: [],
            block_dropdownItem: null,
            village_dropdownItems: [],
            village_dropdownItem: null,


            id: "",
            list: [],
            client_role_group: '',
            status_dropdownItems: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            status_dropdownItem: { name: "Active", value: "Active" },
            show_name: "Add",



            state_dropdownItems: [{ name: 'Andhra Pradesh', value: 'Andhra Pradesh' }, { name: 'Arunachal Pradesh', value: 'Arunachal Pradesh' }, { name: 'Assam', value: 'Assam' }, { name: 'Bihar', value: 'Bihar' }, { name: 'Chhattisgarh', value: 'Chhattisgarh' }, { name: 'Goa', value: 'Goa' }, { name: 'Gujarat', value: 'Gujarat' }, { name: 'Haryana', value: 'Haryana' }, { name: 'Himachal Pradesh', value: 'Himachal Pradesh' }, { name: 'Jharkhand', value: 'Jharkhand' }, { name: 'Karnataka', value: 'Karnataka' }, { name: 'Kerala', value: 'Kerala' }, { name: 'Madhya Pradesh', value: 'Madhya Pradesh' }, { name: 'Maharashtra', value: 'Maharashtra' }, { name: 'Manipur', value: 'Manipur' }, { name: 'Meghalaya', value: 'Meghalaya' }, { name: 'Mizoram', value: 'Mizoram' }, { name: 'Nagaland', value: 'Nagaland' }, { name: 'Odisha', value: 'Odisha' }, { name: 'Punjab', value: 'Punjab' }, { name: 'Rajasthan', value: 'Rajasthan' }, { name: 'Sikkim', value: 'Sikkim' }, { name: 'Tamil Nadu', value: 'Tamil Nadu' }, { name: 'Telangana', value: 'Telangana' }, { name: 'Tripura', value: 'Tripura' }, { name: 'Uttar Pradesh', value: 'Uttar Pradesh' }, { name: 'Uttarakhand', value: 'Uttarakhand' }, { name: 'West Bengal', value: 'West Bengal' }],
            state_dropdownItem: null,






            product: {},
            submitted: false,
            BreadcrumbService : null,
            breadcrumbHome: {},
            breadcrumbItems: [],
        }

    },
    productService: null,
    methods: {

        convert_to_year(data)
        {   
            //const dateString = data;
            const date = new Date(data);
            const year = date.getFullYear();
            return year.toString();

        },
        submit_details()
    { 
      if (this.products==[] || this.products==null || this.products==undefined || this.products.length==0) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Add Atlest one Vehicle",
          life: 3000
        });
        return false;
      }
      for(var i=0;i<this.products.length;i++)
      {
        if(this.products[i].fitness_validity)
        {
          this.products[i].fitness_validity=this.dateFormatYMD(this.products[i].fitness_validity);
        }
        if(this.products[i].puc_validity)
        {
          this.products[i].puc_validity=this.dateFormatYMD(this.products[i].puc_validity);
        }
        if(this.products[i].insurance_validity)
        {
          this.products[i].insurance_validity=this.dateFormatYMD(this.products[i].insurance_validity);
        }
        if(this.products[i].dropdownItem)
        {
          this.products[i].vehicle_type=this.products[i].dropdownItem.value;
        }
        if(this.products[i].district_dropdownItem)
        {
          this.products[i].district=this.products[i].district_dropdownItem.value;
        }
        if(this.products[i].block_dropdownItem)
        {
          this.products[i].block=this.products[i].block_dropdownItem.value;
        }
        if(this.products[i].village_dropdownItem)
        {
          this.products[i].village=this.products[i].village_dropdownItem.value;
        }
        if(this.products[i].make)
        {
          this.products[i].make=this.convert_to_year(this.products[i].make);
        }
        if(this.products[i].make_year)
        {
          this.products[i].make_year=this.convert_to_year(this.products[i].make_year);
        }
         
        // if(this.checkMobile(this.products[i].mobile_number.toString())!='')
        // {
         
        //   alert("Invalid Mobile number "+this.checkMobile(this.products[i].mobile_number.toString()));
        //   return false;
        // }
      }
      var data = {
            "vehicle_details":this.products,
            "client_id":localStorage.getItem("client_id")?localStorage.getItem("client_id"):'',
            "user_id":localStorage.getItem("id")
          
          };

        
         
          this.isLoadingModel = true;
          var promise = apis.bulkvehicleupload_save(data);
          promise
            .then((responseapi) => {
                this.isLoadingModel = false;
                this.$swal(responseapi.data.message);
                this.$router.push({ name: "vehiclemaster" });
                        
                        
                       
            })
            .catch((error) => {
                this.isLoadingModel = false;
                this.$swal(error.response.data);
                this.$router.push({ name: "vehiclemaster" });
  
              
              
            });



    },

     formatDate(year) {
        if (!year) {
            return '';
        }
  const date = new Date(year, 0, 1); // Create a new Date object with the given year and January 1st
  const options = { 
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short'
  }; // Define the formatting options

  const formattedDate = date.toLocaleString('en-US', options); // Format the date as a string

  return formattedDate;
},
         
         
        fileuploaduser(event)
    {
       //alert("here");
      
      console.log(event);
      const input = this.$refs.fileupload1;
      //console.log(input);
      
      if(input.files[0].name.slice((Math.max(0, input.files[0].name.lastIndexOf(".")) || Infinity) + 1)=='xlsx')
      {
        readXlsxFile(input.files[0]).then((rows)=>{
          for(var i=1;i<rows.length;i++)
          {    
           
            this.products.push({
                    
                    registration_number: rows[i][0],
                    mobile_number_rc: rows[i][1],
                    rc_number:rows[i][2],
                    make:rows[i][3].toString(),
                    model:rows[i][4],
                    color:rows[i][5],
                    dropdownItem:{name:rows[i][6],value:rows[i][6]},
                    fuel_type:rows[i][7],
                    make_year:rows[i][8].toString(),
                    fitness_validity:this.dateFormatYMD(rows[i][9]),
                    puc_validity:this.dateFormatYMD(rows[i][10]),
                    insurance_validity:this.dateFormatYMD(rows[i][11]),
                    bcnt:rows[i][12],
                    district_dropdownItem:{name:rows[i][13],value:rows[i][13]},
                    block_dropdownItem:{name:rows[i][14],value:rows[i][14]},
                    village_dropdownItem:{name:rows[i][15],value:rows[i][15]},

                    _id:'0',
                    sr_no:this.products.length+1,
                    status: "Active",
        });
        
          }
          console.log(this.products);
      })
      }
      else
      {
        alert("Please select valid file");
      }
    },
        change_status() 
        {
        this.status = this.status_dropdownItem.value;
        },
        async adduser() 
        {   this.change_status();
                if (!this.status_dropdownItem.value) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select Status",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.registration_number) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter  Registration no.",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.mobile_number_rc) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter  Mobile No",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.rc_number) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Rc Number",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.make) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Make",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.model) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Model",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.color) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Vehicle Color",
                    life: 3000,
                });
                return false;
                }
                if (this.dropdownItem.value=='  ') {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Vehicle Type",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.fuel_type) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Fuel Type",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.make_year) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Make Year",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.fitness_validity) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Fitness Validity",
                    life: 3000,
                });
                return false;
                }
                if (!this.product.puc_validity) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter PUC Validity",
                    life: 3000,
                });
                return false;
                }
                if (!this.product.insurance_validity) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Insurance Validity",
                    life: 3000,
                });
                return false;
                }

                if (!this.product.bcnt) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Base City Name Of Tranportation",
                    life: 3000,
                });
                return false;
                }
                if (this.district_dropdownItem.value=='  ') {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select District Type",
                    life: 3000,
                });
                return false;
                }
                if (this.block_dropdownItem.value=='  ') {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select Block Type",
                    life: 3000,
                });
                return false;
                }
                if (this.village_dropdownItem.value=='  ') {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select Vehicle Type",
                    life: 3000,
                });
                return false;
                }

                var data = {
                    _id:'0',
                    sr_no:this.products.length+1,
                    status: this.status,
                    registration_number: this.product.registration_number,
                    mobile_number_rc: this.product.mobile_number_rc,
                    rc_number:this.product.rc_number,
                    make:this.product.make,
                    model:this.product.model,
                    color:this.product.color,
                    dropdownItem:{name:this.dropdownItem.name,value:this.dropdownItem.value},
                    fuel_type:this.product.fuel_type,
                    make_year:this.product.make_year,
                    fitness_validity:this.product.fitness_validity,
                    puc_validity:this.product.puc_validity,
                    insurance_validity:this.product.insurance_validity,
                    bcnt:this.product.bcnt,
                    // district_dropdownItem:{name:this.district_dropdownItem.name,value:this.district_dropdownItem.value},
                    district_dropdownItem:this.district_dropdownItem.name,
                    block_dropdownItem:{name:this.block_dropdownItem.name,value:this.block_dropdownItem.value},
                    village_dropdownItem:{name:this.village_dropdownItem.name,value:this.village_dropdownItem.value},


                };

                this.products.push(data);

                console.log( this.products);

        },
        confirmDeleteProduct(data)
    { 
    //  if(confirm("Are you sure you want to delete"))
    //  { 
    //   this.products = this.products.filter(item => item.registration_number != data.registration_number);
    //  }
                this.$swal.fire({
                                title: 'Are you sure?',
                                text: "You won't be able to revert this!",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes, delete it!'
                                }).then((result) => {
                                if (result.isConfirmed) {
                                    this.products = this.products.filter(item => item.registration_number != data.registration_number);
                                    this.$swal.fire(
                                    'Deleted!',
                                    'Vehicle has been deleted.',
                                    'success'
                                    )
                                }
                                })
    },












        initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    },
    dateFormatY(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return year;
                }
            }
        }
        else {
           return "";
        }
    },
        dateFormatYMD(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return year+"-"+month+"-"+date;
                }
            }
        }
        else {
           return "";
        }
    },
    handleFileUpload() {
        this.file_attachment='';
      this.file_attachment = this.$refs.file_attachment.files[0];
      this.product.photos=[];
     
      // alert(this.file_attachment);
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async   Add_user() {
        this.submitted = true;

        if (!this.status_dropdownItem.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Status",
            life: 3000,
          });
          return false;
        }

        if (!this.product.registration_number) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter  Registration no.",
            life: 3000,
          });
          return false;
        }

        if (!this.product.mobile_number_rc) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter  Mobile No",
            life: 3000,
          });
          return false;
        }

        if (!this.product.rc_number) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Rc Number",
            life: 3000,
          });
          return false;
        }

        if (!this.product.make) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Make",
            life: 3000,
          });
          return false;
        }

        if (!this.product.model) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Model",
            life: 3000,
          });
          return false;
        }

        if (!this.product.color) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Vehicle Color",
            life: 3000,
          });
          return false;
        }
        if (this.dropdownItem.value=='  ') {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Vehicle Type",
            life: 3000,
          });
          return false;
        }

        if (!this.product.fuel_type) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Fuel Type",
            life: 3000,
          });
          return false;
        }

        if (!this.product.make_year) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Make Year",
            life: 3000,
          });
          return false;
        }

        if (!this.product.fitness_validity) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Fitness Validity",
            life: 3000,
          });
          return false;
        }
        if (!this.product.puc_validity) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter PUC Validity",
            life: 3000,
          });
          return false;
        }
        if (!this.product.insurance_validity) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Insurance Validity",
            life: 3000,
          });
          return false;
        }

        if (!this.product.bcnt) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Base City Name Of Tranportation",
            life: 3000,
          });
          return false;
        }

        this.product.vehicle_type=this.dropdownItem.value;
        var url=[];
        var file=this.file_attachment;
        console.log(file);
        if (file.name && file.type) 
        {       
                url.push("https://media.geoc.in/"+file.name);

                var file_data={
                  filePath:file.name,
                  contentType: file.type
                }
                var promise2 =  apis.uploadFile(file_data);
                promise2
                  .then((response_api) => {
                    
                    axios
                      .put(response_api.data.data, file, {
                        headers: {
                          "Access-Control-Allow-Origin": "*",
                          "Content-Type": file.type,
                        },
                      })
                      .then((response) => {})
                      .catch((error) => {this.$swal("error to upload file");});
                  });
        }
        else
        {   
            if (this.product.photos && this.product.photos[0]) {
                url=this.product.photos[0];
            }
        }



              if (this.product._id) {
                var data1 = {
                    "_id": this.product._id,

                    "status": this.status_dropdownItem.value,
                    "registration_number": this.product.registration_number,
                    "mobile_number_rc": this.product.mobile_number_rc,
                    "rc_number": this.product.rc_number,
                    "make": this.product.make,
                    "model": this.product.model,
                    "color":this.product.color,
                    "vehicle_type": this.product.vehicle_type,
                    "fuel_type":this.product.fuel_type,
                    "make_year":this.product.make_year,
                    "fitness_validity":this.dateFormatYMD(this.product.fitness_validity),
                    "puc_validity":this.dateFormatYMD(this.product.puc_validity),
                    "insurance_validity":this.dateFormatYMD(this.product.insurance_validity),
                    "bcnt":this.product.bcnt,
                    "owner_id":this.id,
                    "updated_at": "",
                    "updated_by": this.id,
                    "client_id":localStorage.getItem("client_id")?localStorage.getItem("client_id"):'',
                    "photo":url,
                };
                this.isLoadingModel = true;
                var promise =  apis.editvehicle(data1);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.reset_user();
                        this.$router.push({ name: "vehiclemaster" });

                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.$swal.fire(error.response.data);

                    });
            }
            else {

                var data = {
                    "status": this.status_dropdownItem.value,
                    "registration_number": this.product.registration_number,
                    "mobile_number_rc": this.product.mobile_number_rc,
                    "rc_number": this.product.rc_number,
                    "make": this.product.make,
                    "model": this.product.model,
                    "color":this.product.color,
                    "vehicle_type": this.product.vehicle_type,
                    "fuel_type":this.product.fuel_type,
                    "make_year":this.product.make_year,
                    "fitness_validity":this.dateFormatYMD(this.product.fitness_validity),
                    "puc_validity":this.dateFormatYMD(this.product.puc_validity),
                    "insurance_validity":this.dateFormatYMD(this.product.insurance_validity),
                    "bcnt":this.product.bcnt,
                    "owner_id":this.id,
                    "created_at": "",
                    "created_by": this.id,
                    "client_id":localStorage.getItem("client_id")?localStorage.getItem("client_id"):'',
                    "photo":url,
                    



                };

               
                this.isLoadingModel = true;
                var promise1 =  apis.addvehicle(data);
                promise1
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.reset_user();
                        this.$router.push({ name: "vehiclemaster" });

                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.$swal.fire(error.response.data);

                    });
            }

           

        },
        get_vehicle_type_master() {
            this.loading = true;
            var data = {
                client_id:localStorage.getItem("client_id")
                
            };
            var promise = apis.vehicle_type_master(data);
            promise.then((response) => {
                this.loading = false;
                console.log(response);
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name, value: response.data.data[x].name
                        });

                    }
                    this.dropdownItems = temp_data;
                }

            });
        },


        get_district_master() {
            this.loading = true;
            var data = {
                client_id:localStorage.getItem("client_id"),
                count: false,
                service_name: this.service_name,
                
            };
            var promise = apis.getStateData(data);
            promise.then((response) => {
                this.loading = false;
                
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name, value: response.data.data[x].name
                        });

                    }
                    this.district_dropdownItems = temp_data;
                }

            });
        },
        get_block_master() {
            this.loading = true;
            var data = {
                client_id:localStorage.getItem("client_id"),
                count: false,
                service_name: this.service_name,
                
            };
            var promise = apis.getBlockData(data);
            promise.then((response) => {
                this.loading = false;
                
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name, value: response.data.data[x].name
                        });

                    }
                    this.block_dropdownItems = temp_data;
                }

            });
        },
        get_village_master() {
            this.loading = true;
            var data = {
                limit:1000,
                client_id:localStorage.getItem("client_id"),
                count: false,
                service_name: this.service_name,
                district_name:this.block_dropdownItem
                
            };
            var promise = apis.getVillageData(data);
            promise.then((response) => {
                this.loading = false;
                
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].village_name, value: response.data.data[x].village_name
                        });

                    }
                    this.village_dropdownItems = temp_data;
                }

            });
        },
       

        reset_user() {
            this.product = {};
            this.submitted = false;
            this.status_dropdownItem = null;
            this.dropdownItem = null;
            this.state_dropdownItem = null;
            this.location_search = '';
            this.$refs.file_attachment.files='';
            this.show_name = "Add";
            this.products=[];
        },
    },
    async created() {
        this.productService = new ProductService();

        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.vehicle_add()
        this.breadcrumbHome=Breadcrum_data.home;
        this.breadcrumbItems=Breadcrum_data.items;


        this.id = localStorage.getItem('id');
       
        if (localStorage.getItem('savevehicledata')) {
            this.product = await JSON.parse(localStorage.getItem('savevehicledata'));
            this.status_dropdownItem = {};
            this.status_dropdownItem.value = await this.product.status;
            this.status_dropdownItem.name = await this.product.status;

            if (this.product.vehicle_type) 
        {
            this.dropdownItem={};
            this.dropdownItem.value = await this.product.vehicle_type;
            this.dropdownItem.name  = await this.product.vehicle_type;
        }

            this.show_name = "Update"

            

        }

        this.get_vehicle_type_master();
        this.get_district_master();
        this.get_block_master();
        this.get_village_master();

        await localStorage.setItem('savevehicledata', '');




    },

    components: { downloadExcel: JsonExcel },
}
</script>
